import OoHeader from './src/main.vue';

/* istanbul ignore next */
OoHeader.install = function(Vue) {
  Vue.component(OoHeader.name, OoHeader);
};

export default OoHeader;


// WEBPACK FOOTER //
// ./src/packages/header/index.js